// extracted by mini-css-extract-plugin
export default {"button":"styles_button__Upf+1","animate":"styles_animate__FY64L","buttonText":"styles_buttonText__XY1Ms"};